// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1DhCH","fullScreen":"style_fullScreen__3Mumf","hidden":"style_hidden__2A-Yk"};